/**
 * Initials for an avatar bubble. Two letters from a full name (first + last
 * word), else the first two characters of the name/email, else "?".
 *
 * Extracted from PinSwitchScreen so every admin-avatar surface shares one
 * implementation (header, PIN switch, admin list/detail, activity log).
 */
export function initials(name: string | null | undefined, email: string | null | undefined): string {
  const base = name?.trim() || email?.trim() || '?';
  const parts = base.split(/\s+/);
  if (parts.length >= 2 && parts[0] && parts[1]) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return base.slice(0, 2).toUpperCase();
}
